export enum AUDIO_NOTE_SKIP_DIRECTION {
    forward = 'forward',
    backward = 'backward',
}
